import React from 'react';

const Dashboard = () => <p className='tw-text-5xl tw-font-bold'>Hello from Dashboard</p>;

export default Dashboard;
